import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginService } from '../services/login.service';
import { ToastModule } from 'primeng/toast';



@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  providers: [LoginService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'TierPhys.Frontend';

}
